import React from 'react';
import PropTypes from 'prop-types';

export default function FlexPageBody(props) {
  const { children, ...rest} = props;

  if (rest.id) {
    delete rest.id
  }

  return (
    <div
      id="page-content"
      {...rest}>
      {children}
    </div>
  );
}

FlexPageBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
